import { useCallback } from "react";
import { useAthlete, useRequest } from "hooks";
import useAthleteActions from "providers/AthletesProvider/useAthleteActions";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import ArchiveAthleteDialog from "../components/ArchiveAthleteDialog";
import useBoolean from "hooks/useBoolean";
import useAthleteLimits from "hooks/useAthleteLimits";
import Button from "components/Button";

interface ArchiveAthleteActionProps {
  athleteId: string;
}

function ArchiveAthleteAction(props: ArchiveAthleteActionProps) {
  const { athleteId } = props;

  const { t } = useTranslation();
  const { value: open, setTrue, setFalse } = useBoolean();
  const athleteActions = useAthleteActions();
  const athlete = useAthlete(athleteId);
  const athleteLimits = useAthleteLimits();

  const handleArchiveAthlete = useRequest(athleteActions.toggleArchived, true);

  const handleToggleArchived = useCallback(async () => {
    if (!athlete) return;
    await handleArchiveAthlete(athleteId, !athlete.isArchived);
    setFalse();
  }, [athlete, athleteId, handleArchiveAthlete, setFalse]);

  if (!athlete) return null;

  return (
    <ThemeProvider2024>
      <Button
        disabled={athleteLimits.archived.isFull}
        variant="secondary"
        fullWidth
        onClick={setTrue}
        startIcon={<ArchiveOutlinedIcon fontSize="small" />}
      >
        {t("edit_athlete.archive_button_text")}
      </Button>
      <ArchiveAthleteDialog open={open} onCancel={setFalse} onConfirm={handleToggleArchived} athlete={athlete} />
    </ThemeProvider2024>
  );
}

export default ArchiveAthleteAction;
